export const APP_VERSION = 'a63bb694-1786084351924'
